// components/BottomTabNavigator.js
import React from 'react';
import { NavLink } from 'react-router-dom';
import {Home} from 'lucide-react'
import './BottomTabNavigator.css';

function BottomTabNavigator() {

   const quickAccessTabs = [
      {
        path: "/MainCalendar2",
        label: "Kalender",
        imgSrc: "./assets/timetable.png",
      },
      { path: "/team", label: "Team", imgSrc: "./assets/work-time.png" },
      {
        path: "/addanr",
        label: "Projekt",
        imgSrc: "./assets/project-management.png",
      },
      {
        path: "/anrTable",
        label: "Aufgaben",
        imgSrc: "./assets/task-management.png",
      },
      { path: "/", label: "Dashboard", icon: <Home className="w-5 h-5" /> },
    ];
  
  return (
            <div className="fixed bottom-0 left-0 right-0 z-40">
              <div className="flex justify-center w-full bg-white shadow-lg border-t border-gray-200">
                <div className="flex justify-around w-full max-w-md">
                  {quickAccessTabs.map((tab, index) => (
                    <NavLink
                      key={index}
                      to={tab.path}
                      className={({ isActive }) =>
                        `flex flex-col items-center py-2 px-3 text-xs font-medium ${
                          isActive
                            ? "text-blue-600"
                            : "text-gray-600 hover:text-blue-500"
                        }`
                      }
                    >
                      {tab.imgSrc ? (
                        <img src={tab.imgSrc} alt={tab.label} className="w-6 h-6" />
                      ) : (
                        tab.icon
                      )}
                      <span className="mt-1">{tab.label}</span>
                    </NavLink>
                  ))}
                </div>
              </div>
    </div>
  );
}

export default BottomTabNavigator;
